import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { MOBILE_TRAVEL_PLAN } from '../../products';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useProductData } from '../../common/hook/useProductData';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = MOBILE_TRAVEL_PLAN;
const sharedTexts = {
  persuasionContent: 'mobileTravelPlanPersuasionContent',
  readMoreContent: 'mobileTravelPlanReadMoreModalContent',
  title: 'mobileTravelPlanTitle'
};
const mainCardTranslations = {
  ...sharedTexts,
  upSell: 'mobileTravelPlanUpSellText',
  additionalInformation: 'mobileTravelPlanAdditionalInformation',
  abstractContent: 'mobileTravelPlanAbstract'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'mobileTravelPlanAbstractSmallCard',
    upSell: 'mobileTravelPlanUpSellTextSmallCard'
  }
};
const MobileTravelPlan = ({
  className,
  form,
  isSelected,
  layoutType = MAIN_CARD_LAYOUT,
  order,
  productCode,
  productPosition
}) => {
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    texts
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, {
  form
}) => ({
  isSelected: getSelected(PRODUCT_NAME, form)(state)
});
export default connect(mapStateToProps)(MobileTravelPlan);
//# sourceMappingURL=MobileTravelPlan.js.map